import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { ensureValidQueryData } from "@/api/utils/ensureValidQueryData"
import { routeGuard } from "@/lib/routing/beforeLoad"

import { templateQuery } from "./-templateQuery"

export const Route = createFileRoute("/_authlayout/_header/templates/$id")({
  beforeLoad: async ({ context, params }) => {
    await routeGuard(context, { permission: { flag: "iot:template::read" } })

    return { templateQuery: templateQuery(context.spaceStorage.getSpace(), params.id) }
  },
  loader: async ({ context: { queryClient, templateQuery: template } }) => {
    // Legacy Arduino templates are static content (not user-deletable), so
    // there is no deletion case to guard against for them.
    if (!template.isUUID) {
      const { data, error } = await ensureValidQueryData(template.options)

      if (error) throw notFound()

      return { template: { data, isUUID: false as const } }
    }

    // Must be read before validating, since a determinate 4xx evicts the query.
    const wasCached = queryClient.getQueryData(template.options.queryKey) !== undefined

    const { data, error } = await ensureValidQueryData(template.options)

    if (error) {
      // Deleted under us → back to the custom list. Otherwise a bad id → 404.
      if (wasCached) throw redirect({ to: "/templates", search: { tab: "custom" } })
      throw notFound()
    }

    return { template: { data, isUUID: true as const } }
  }
})
